import {useEventEarning} from 'organization/Event/Earning/EventEarningProvider'
import {ListBalance} from 'organization/Event/Earning/ListBalance'
import EventPage from 'organization/Event/EventPage'
import BreadcrumMenu from 'organization/theme/Breadcrum'
import React from 'react'
import styled from 'styled-components'
import {Pagination} from '@mui/material'
import {EventFaqHelp} from 'organization/Event/Help/FAQ'
import {useI18n} from 'i18n/I18nContext'

export const Earning = () => {
  const {t} = useI18n()
  const {totalProfit, balance, totalPages, page, changePage} = useEventEarning()

  return (
    <EventPage>
      <>
        <div className="row pl-30 pb-30 pr-30">
          <BreadcrumMenu
            title={t('org.menu.earnings')}
            helpInfo={<EventFaqHelp faqKey="profitPage" />}
          />

          <div className="col-12">
            <div className="create__event-area">
              <div className="body__card-wrapper attendant__wrapper">
                <MainInfoHolder>
                  <div>
                    <p style={{fontSize: '1.5rem'}}>
                      {t('orgEarnings.totalRevenue')}{' '}
                      <b>{totalProfit.toFixed(2)} €</b>
                    </p>
                  </div>
                </MainInfoHolder>

                <table>
                  <thead>
                    <tr>
                      <th>{t('orgTable.colNo')}</th>
                      <th>{t('orgTable.colDate')}</th>
                      <th>{t('orgTable.colType')}</th>
                      <th>{t('orgTable.colTicketTier')}</th>
                      <th>{t('orgTable.colDescription')}</th>
                      <th>{t('orgTable.colAmount')}</th>
                      <th>{t('orgTable.colPlatformFee')}</th>
                      <th>{t('orgTable.colYourShare')}</th>
                      <th>{t('orgTable.colStatus')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {balance.length === 0 && (
                      <tr>
                        <td colSpan={9}>{t('orgTable.empty')}</td>
                      </tr>
                    )}
                    {balance &&
                      balance.map((item, index) => (
                        <ListBalance balance={item} index={index} />
                      ))}
                  </tbody>
                </table>

                <PaginationHolder>
                  <Pagination
                    count={totalPages}
                    shape="rounded"
                    page={page}
                    onChange={changePage}
                  />
                </PaginationHolder>
              </div>
            </div>
          </div>
        </div>
      </>
    </EventPage>
  )
}

const MainInfoHolder = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--clr-border-1);
  padding-bottom: 40px;
  margin-bottom: 20px;
`

const PaginationHolder = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 30px;
`
